import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";
import CookieConsent from "@/components/CookieConsent";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import BengaliPath from "@/pages/BengaliPath";
import Apply from "@/pages/Apply";
import Waitlist from "@/pages/Waitlist";
import Admin from "@/pages/Admin";
import AdminLogin from "@/pages/AdminLogin";
import Legal from "@/pages/Legal";
import AiLabs from "@/pages/AiLabs";
import Experts from "@/pages/Experts";
import HowItWorks from "@/pages/HowItWorks";
import About from "@/pages/About";
import Pilot from "@/pages/Pilot";

function AppRouter() {
  const location = useLocation();
  // Route scroll reset — every new route opens at the top. Keyed on pathname only,
  // so it never interferes with the auth history.replaceState / callback fragment flow.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  // Detect session_id in URL fragment synchronously during render (prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/ai-labs" element={<AiLabs />} />
      <Route path="/experts" element={<Experts />} />
      <Route path="/how-it-works" element={<HowItWorks />} />
      <Route path="/about" element={<About />} />
      <Route path="/pilot" element={<Pilot />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/apply" element={<Apply />} />
      <Route path="/waitlist" element={<Waitlist />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/admin/dashboard" element={<Admin />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/path/bengali" element={<BengaliPath />} />
      <Route path="/terms" element={<Legal doc="terms" />} />
      <Route path="/privacy" element={<Legal doc="privacy" />} />
      <Route path="/cookie" element={<Legal doc="cookie" />} />
      <Route path="/anti-scam" element={<Legal doc="antiscam" />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <CookieConsent />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
